import { fetchSuggestedCollections,fetchTiktokCollections } from '~/api/stores/tiktok'

const state = () => ({
  tiktokCollection: [],
  suggestedCollections: [],
})

const getters = {
  tiktokCollection: (state) => state.tiktokCollection,
  suggestedCollections: (state) => state.suggestedCollections,
}

const mutations = {
  setCollections(state, data) {
    state.tiktokCollection = data
  },
  setSuggestedCollections(state, data) {
    state.suggestedCollections = data
  },
}

const actions = {
  async fetchTiktokCollections({ commit }, parentId = 0) {
    try {
      const tiktokCollection = await fetchTiktokCollections(parentId)

      commit('setCollections', tiktokCollection)
    } catch (e) {
      console.error(e)
    }
  },

  async fetchSuggestedCollections({ commit }, productName) {
    try {
      const suggestedCollections = await fetchSuggestedCollections(productName)

      commit('setSuggestedCollections', suggestedCollections)
    } catch (e) {
      commit('setSuggestedCollections', [])
      console.error(e)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
